import type {InventoryPresenter} from 'src/features/inventory/inventory.presenter';

export class InventoriesPageService {
    public static serviceName = 'inventoriesPageService';

    /*@ngInject*/
    constructor(private inventoryPresenter: InventoryPresenter) {
    }

    public async createInventory(): Promise<void> {
        await this.inventoryPresenter.createInventory();
    }
}